import { Grid } from "@material-ui/core";

import AutoCompleteField from "components/_refactor/fields/autocomplete";
import InputText from "components/_refactor/text/input";

import MaskAndValid from "utils/maskAndValid";

import regionOptionsRaw from "../../publicar-vitrine/data/brazil-regions.json";
import { DEFAULT_REPRESENTATIVE_LIST_FILTERS } from "../utils/representative-helpers";

const regionOptions = [
  { label: "Todas", value: "" },
  ...regionOptionsRaw,
];

const statusOptions = [
  { id: "TODOS", value: "TODOS", label: "Todos" },
  { id: "ATIVO", value: "ATIVO", label: "Ativo" },
  { id: "INATIVO", value: "INATIVO", label: "Inativo" },
];

const defaultStatus = statusOptions[0];

export default function RepresentativeFilters({
  isLoading,
  filters,
  onFiltersChange,
  grupoEconomicoOptions = [],
  razaoSocialOptions = [],
  showSearchInGrid = false,
}) {
  const handleChange = (key, value) => {
    onFiltersChange({ [key]: value });
  };

  const handleCnpjChange = (e) => {
    handleChange("cnpj", MaskAndValid.maskCNPJ(e.target.value));
  };

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <AutoCompleteField
          options={statusOptions}
          label="Status"
          optionLabelKey="label"
          optionIdKey="id"
          onChange={(option) => handleChange("status", option ?? defaultStatus)}
          disabled={isLoading}
          value={filters?.status ?? defaultStatus}
          disableClientFilter
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <AutoCompleteField
          options={regionOptions}
          label="Região"
          optionLabelKey="label"
          optionIdKey="value"
          onChange={(option) => handleChange("region", option)}
          disabled={isLoading}
          value={filters?.region}
          disableClientFilter
          required={false}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <AutoCompleteField
          options={grupoEconomicoOptions}
          label="Grupo Econômico"
          optionLabelKey="Nome"
          optionIdKey="Id"
          onChange={(option) => handleChange("grupoEconomico", option)}
          disabled={isLoading}
          value={filters?.grupoEconomico}
          disableClientFilter
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <AutoCompleteField
          options={razaoSocialOptions}
          label="Razão Social"
          optionLabelKey="Nome"
          optionIdKey="Id"
          onChange={(option) => handleChange("razaoSocial", option)}
          disabled={isLoading}
          value={filters?.razaoSocial}
          disableClientFilter
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={2}>
        <InputText
          placeholder="00.000.000/0000-00"
          onChange={handleCnpjChange}
          disabled={isLoading}
          value={filters?.cnpj || ""}
          label="CNPJ"
        />
      </Grid>
      {showSearchInGrid && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <InputText
            placeholder="Pesquisar..."
            onChange={(e) => handleChange("search", e.target.value)}
            disabled={isLoading}
            value={filters?.search || ""}
            label="Pesquisar"
          />
        </Grid>
      )}
    </Grid>
  );
}

export { DEFAULT_REPRESENTATIVE_LIST_FILTERS };
